import React from 'react';
import { Pagination } from 'rsuite';
import { PAGINATION_LOCALE, renderPaginationTotal } from './paginationLocale';

type TablePaginationProps = {
  total: number;
  activePage: number;
  limit: number;
  onChangePage: (page: number) => void;
  onChangeLimit: (limit: number) => void;
  pages?: number;
  limitOptions?: number[];
  className?: string;
};

/**
 * Shared table pagination for admin pages.
 * @param props
 */
export default function TablePagination({
  total,
  activePage,
  limit,
  onChangePage,
  onChangeLimit,
  pages,
  limitOptions = [15, 30, 50, 100],
  className,
}: TablePaginationProps) {
  const classes = ['table-pagination', className].filter(Boolean).join(' ');
  const safeActivePage = activePage > 0 ? activePage : 1;

  return (
    <div className={classes}>
      <span className="pagination-info">
        {renderPaginationTotal(total, safeActivePage, limit)}
      </span>
      <Pagination
        layout={['pager', '|', 'limit']}
        locale={PAGINATION_LOCALE}
        total={total}
        maxButtons={5}
        prev
        next
        ellipsis
        limitOptions={limitOptions}
        limit={limit}
        onChangeLimit={onChangeLimit}
        activePage={safeActivePage}
        pages={pages}
        onChangePage={onChangePage}
      />
    </div>
  );
}
